/**
 * Share the app via Capacitor Share API, Web Share, or clipboard fallback.
 * Replaces `share-app.js`.
 */

import { createLogger } from '../../core/logger.js';
import * as alert from '../../core/alert.js';

const log = createLogger('share');

const SHARE_URL = 'https://autome.co.il';
const SHARE_TITLE = 'AutoMe';
const SHARE_TEXT = 'AutoMe — צור קשר עם בעל הרכב בקליק. הורד את האפליקציה:';

/**
 * Open the platform share sheet. Falls back to copying the link to clipboard.
 * @returns {Promise<{ shared: boolean; method: 'capacitor' | 'webshare' | 'clipboard' | 'none' }>}
 */
export async function shareApp() {
  const capacitor = /** @type {any} */ (window).Capacitor;
  const Share = capacitor?.Plugins?.Share;
  if (Share) {
    try {
      await Share.share({
        title: SHARE_TITLE,
        text: SHARE_TEXT,
        url: SHARE_URL,
        dialogTitle: 'שתף את AutoMe',
      });
      return { shared: true, method: 'capacitor' };
    } catch (err) {
      log.warn('Capacitor Share failed:', /** @type {Error} */ (err).message);
    }
  }
  if (/** @type {any} */ (navigator).share) {
    try {
      await /** @type {any} */ (navigator).share({
        title: SHARE_TITLE,
        text: SHARE_TEXT,
        url: SHARE_URL,
      });
      return { shared: true, method: 'webshare' };
    } catch (err) {
      log.warn('Web Share failed:', /** @type {Error} */ (err).message);
    }
  }
  // Clipboard fallback
  try {
    await navigator.clipboard.writeText(`${SHARE_TEXT} ${SHARE_URL}`);
    alert.showToast('הקישור הועתק — אפשר להדביק בכל מקום ולשלוח.', { kind: 'success' });
    return { shared: true, method: 'clipboard' };
  } catch (err) {
    log.warn('Clipboard fallback failed:', err);
  }
  alert.showToast('שיתוף נכשל. נסה שוב מאוחר יותר.', { kind: 'error' });
  return { shared: false, method: 'none' };
}

/** Copy raw text to the clipboard with a toast confirmation. */
export async function copyToClipboard(/** @type {string} */ text) {
  try {
    await navigator.clipboard.writeText(text);
    alert.showToast('הועתק', { kind: 'success', duration: 1500 });
    return true;
  } catch (err) {
    log.warn('copyToClipboard failed:', err);
    return false;
  }
}
